import { render, staticRenderFns } from "./9_001_smwx.vue?vue&type=template&id=1ba84308"
import script from "./9_001_smwx.vue?vue&type=script&lang=js"
export * from "./9_001_smwx.vue?vue&type=script&lang=js"
import style0 from "./9_001_smwx.vue?vue&type=style&index=0&id=1ba84308&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports